const loginPageInitialState = {
	accountCategory: 'commoner',
	cardAnimation: 'cardHidden',
	error: null,
	showError: false,
	success: false,
	token: '',
	username: '',
	loggedUserId: '',
	resettingPasswordSucceed: false,
	resettingPasswordFailed: false,
	resetPasswordTimeoutFailed: false,
	changedPasswordEmail: '',
	incorrectToken: false,
	clickedButtonDisabled: false,
};

export default loginPageInitialState;
